module.exports = __webpack_public_path__ + "img/2.6_Indigenous-Advisory-Group_5_Egert.14749164e25d92e900878b60f50569dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_Indigenous-Advisory-Group_5_Egert.png
// module id = 790
// module chunks = 0